import HttpService from '@/services/HttpService';
import ConfigHelper from '@/util/ConfigHelper';

export default class VbrGebouwService {
  constructor(public http: HttpService) {}

  async getGebouweenhedenForGebouw(gebouwId: string): Promise<VbrGebouwEenheid[]> {
    const respGebouwen = await this.http.get<VbrGebouw>(ConfigHelper.getBasisRegistersUrl() + '/gebouwen/' + gebouwId);
    if (
      respGebouwen.gebouwStatus === 'gerealiseerd' ||
      respGebouwen.gebouwStatus === 'gepland' ||
      respGebouwen.gebouwStatus === 'inAanbouw'
    ) {
      return respGebouwen.gebouweenheden;
    }
    return [];
  }

  async getGebouweenheidDetail(url: string): Promise<VbrGebouwEenheidDetail> {
    const gebouweenheid = await this.http.get<VbrGebouwEenheidDetail>(url);
    gebouweenheid.statusGeldig =
      gebouweenheid.gebouweenheidStatus === 'gerealiseerd' || gebouweenheid.gebouweenheidStatus === 'gepland';

    if (gebouweenheid.statusGeldig) {
      if (gebouweenheid.adressen.length > 0) {
        gebouweenheid.adressen[0] = await this.getAdresDetail(gebouweenheid.adressen[0].detail);
      }
    }

    return gebouweenheid;
  }

  async getAdresDetail(url: string): Promise<VbrAdres> {
    return await this.http.get<VbrAdres>(url);
  }
}

export type VbrGebouw = {
  gebouwStatus: string;
  gebouweenheden: VbrGebouwEenheid[];
};

export type VbrGebouwEenheid = {
  objectId: string;
  detail: string;
};

export type VbrGebouwEenheidDetail = {
  gebouweenheidStatus: string;
  statusGeldig: boolean;
  functie: string;
  adressen: VbrAdres[];
  identificator: {
    objectId: string;
  };
};

type VbrAdres = {
  detail: string;
  volledigAdres: {
    geografischeNaam: {
      spelling: string;
    };
  };
};
